import { render } from "./SvgImage.vue?vue&type=template&id=2719b272&scoped=true"
import script from "./SvgImage.vue?vue&type=script&lang=js"
export * from "./SvgImage.vue?vue&type=script&lang=js"

import "./SvgImage.vue?vue&type=style&index=0&id=2719b272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2719b272"]])

export default __exports__